import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UigNewsConnector } from '../uig-news.connector';
import { UigNewsItem, UigNewsFeedObjNormalized } from '../uig-news.model';

@Component({
    selector: 'app-uig-news-feed',
    templateUrl: './uig-news-feed.component.html',
    styleUrls: ['./uig-news-feed.component.scss'],
    standalone: false
})
export class UigNewsFeedComponent implements OnInit {
  public news$ = new BehaviorSubject<UigNewsItem[]>(undefined);

  constructor(private uigNewsCnn: UigNewsConnector) {}

  ngOnInit(): void {
    this.fetchNews();
  }

  // Issues the getNews() request and adapts the response to the structure that's needed in the template
  private fetchNews(): void {
    // Unsubscribe is not required since this it's an HTTP call which will get unsubscribed automatically
    this.uigNewsCnn
      .getNews()
      .pipe(filter(Boolean))
      .subscribe((news: any) => {
        const newsFeedObjNormalized: UigNewsFeedObjNormalized[] = [{
          date: '',
          newsItems: []
        }];
        let newsFeedDayChunk: UigNewsFeedObjNormalized;
        let tempIndexNewDateFound: number = 0;

        newsFeedObjNormalized[0].date = news[0].date;

        for (const [index, newsItem] of news.entries()) {
          if (newsItem.date) {
            if (!this.isSameDay(newsFeedObjNormalized[tempIndexNewDateFound].date, news[index].date)) {
              newsFeedDayChunk = {
                date: newsItem.date,
                newsItems: [newsItem]
              }
              newsFeedObjNormalized.push(newsFeedDayChunk);
              tempIndexNewDateFound += 1;
            } else {
              newsFeedObjNormalized[tempIndexNewDateFound].newsItems.push(newsItem);
            }
          }
        }
        this.news$.next(newsFeedObjNormalized);
      });
  }

  // Checks if the 2 timestamps occur during the same day
  private isSameDay(d1: string, d2: string): boolean {
    const prevDay: Date = new Date(d1);
    const currDay: Date = new Date(d2);

    return (
      prevDay.getFullYear() === currDay.getFullYear() &&
      prevDay.getMonth() === currDay.getMonth() &&
      prevDay.getDate() === currDay.getDate()
    );
  }
}
